import "../App.css";
import { React, useState } from "react";
import {
  createTheme,
  TextField,
  Typography,
  Box,
  IconButton,
  Paper,
  Grid,
  Avatar,
  InputAdornment,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/joy/Button";
import { Form, Formik, Field, ErrorMessage } from "formik";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import background from "../login_bg.jpg";
import Notification from "../popup/Notification";
import ConfirmDialog from "../dialog/ConfirmDialog";
import Axios from "../api/Axios";
import * as Yup from "yup";
import YupPassword from "yup-password";
import { useNavigate, useLocation } from "react-router-dom";

const theme = createTheme();

const avatarStyle = { backgroundColor: "green", marginTop: "1vh" };

const titleStyle = { color: "#8d4004" };

YupPassword(Yup);

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let email = location.state.email;

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [requestingOtp, setRequestingOtp] = useState(false);

  const imgStyle = {
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    height: "100vh",
  };

  const buttonStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const usernameStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const passwordStyle = {
    marginLeft: "1vh",
    marginTop: "2.5vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const typographyStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };
  const otpStyle = {
    marginLeft: "1vh",
    marginTop: "2vh",
    marginRight: "1vh",
    marginBottom: "1vh",
  };

  const initialValues = {
    otp: "",
    password: "",
    confirm_password: "",
  };
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .required("Required")
      .matches(/^[0-9]\d{3}$/, {
        message: "Please enter valid OTP",
        excludeEmptyString: false,
      }),
    password: Yup.string()
      .required("Required")
      .min(
        8,
        "Password must contain 8 or more characters with at least one of each: Uppercase, Lowercase, Number and Special character"
      )
      .max(20, "Password too long")
      .minLowercase(1, "Password must contain at least 1 Lower case letter")
      .minUppercase(1, "Password must contain at least 1 Upper case letter")
      .minNumbers(1, "Password must contain at least 1 Number")
      .minSymbols(1, "Password must contain at least 1 Special character"),
    confirm_password: Yup.string()
      .required("Required")
      .oneOf([Yup.ref("password")], "Passwords do not match"),
  });

  const PASSWORD_RESET_URL = "/api/v1/users/reset-password";
  const onSubmit = async (values, props) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });

    const otp = values.otp;
    const password = values.password;
    const confirmPassword = values.confirm_password;

    try {
      const response = await Axios.post(
        PASSWORD_RESET_URL,
        { otp, email, password, confirmPassword },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data.message);

      // clear input fields
      props.resetForm();
      props.setSubmitting(false);

      setNotify({
        isOpen: true,
        message: response.data.message,
        type: "success",
      });

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 2000);
    } catch (error) {
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      setConfirmDialog({
        isOpen: true,
        title: "Request Failed",
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: { onSubmit },
      });
    }
  };

  const OTP_URL = "/api/v1/users/generate-password-reset-otp";
  const onResendOtp = async (values, props) => {
    setRequestingOtp(true);

    try {
      const response = await Axios.post(
        OTP_URL,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data.message);
      setRequestingOtp(false);

      setNotify({
        isOpen: true,
        message: response.data.message,
        type: "success",
      });
    } catch (error) {
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      setConfirmDialog({
        isOpen: true,
        title: "Request Failed",
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: { onSubmit },
      });
    }
  };

  return (
    <div style={imgStyle}>
      <Box sx={{ display: "flex" }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Paper
            elevation={10}
            sx={{
              marginLeft: { xs: 8, sm: 20, md: 28, lg: 74, xl: 64 }, // xs=iPhone SE; sm=iPad Mini; md=iPad pro; lg=Nest Hub Max
              marginRight: { xs: 7, sm: 20, md: 28, lg: 74, xl: 64 },
              marginTop: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
              marginBottom: 4,
              paddingLeft: theme.spacing(2),
              paddingTop: theme.spacing(2),
              paddingRight: theme.spacing(4),
              paddingBottom: theme.spacing(2),
            }}
          >
            <Grid align="center">
              <Avatar style={avatarStyle}>
                <LockOutlinedIcon></LockOutlinedIcon>
              </Avatar>

              <h2 style={titleStyle}>BuuKipa BuuKipa</h2>
              <h2>Reset Password</h2>
              <h5>
                Enter the OTP sent to the email provided, then new password and
                confirm password
              </h5>

              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {(props) => (
                  <Form>
                    <Field
                      as={TextField}
                      label="OTP"
                      name="otp"
                      placeholder="Enter OTP"
                      style={otpStyle}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="otp">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                    />
                    <Typography align="right">
                      <Button
                        size="sm"
                        loading={requestingOtp}
                        loadingPosition="start"
                        variant="plain"
                        style={{
                          textDecorationLine: "underline",
                        }}
                        onClick={onResendOtp}
                      >
                        Resend OTP
                      </Button>
                    </Typography>

                    <Field
                      as={TextField}
                      label="Password"
                      name="password"
                      placeholder="Enter password"
                      style={passwordStyle}
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="password">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Field
                      as={TextField}
                      label="Confirm Password"
                      name="confirm_password"
                      placeholder="Enter password"
                      style={passwordStyle}
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      required
                      helperText={
                        <ErrorMessage name="confirm_password">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Button
                      type="submit"
                      color="primary"
                      fullWidth
                      loading={props.isSubmitting}
                      loadingPosition="start"
                      variant="solid"
                      style={buttonStyle}
                    >
                      {props.isSubmitting ? "Processing" : "Submit"}
                    </Button>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Paper>

          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Grid>
      </Box>
    </div>
  );
};

export default ResetPassword;
